<svg width="24" height="24" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
 <g transform="translate(3,3)">
  <path d="m16 2v14h-14v-14zm0-2h-14c-1.1 0-2 0.9-2 2v14c0 1.1 0.9 2 2 2h14c1.1 0 2-0.9 2-2v-14c0-1.1-0.9-2-2-2z"/>
  <polygon points="8.14 12.73 6 10.14 3 14 15 14 11.14 8.86"/>
 </g>
</svg>
